import { combineReducers } from 'redux';
import activateDeals from '@common/ActivateDeals/reducers';
import addToCart from '@common/AddToCart/reducers';
import addToCartFeedback from '@common/AddToCartFeedback/reducers';
import checkout from '@common/Checkout/Checkout/reducers';
import sharedCart from '@common/Checkout/SharedCart/reducers';
import checkoutShopcart from '@common/Checkout/Shopcart/reducers';
import thankYouPage from '@common/Checkout/ThankYou/reducers';
import CMS from '@common/CMS/reducers';
import collections from '@common/Collections/reducers';
import CS from '@common/CS/reducers';
import { customer } from '@common/Customer/reducers';
import {
    dashboard, dashboardClub, orderReturn, ordersById, returns
} from '@common/Dashboard/reducers';
import dialog from '@common/Dialog/reducers/dialogReducers';
import favorites from '@common/Favorites/reducers/favoritesReducers';
import filters from '@common/Filters/reducers/filtersReducers';
import globalSearch from '@common/GlobalSearch/reducers';
import sideNavigation from '@common/LeftNavigation/reducers/SideNavigationReducers';
import listing from '@common/Listing/reducers/listingReducers';
import myLists from '@common/MyLists/store/reducers/MyListsReducers';
import newsletterSignup from '@common/NewsletterSignupForm/reducers/signupStatusReducers';
import voucher from '@common/NewsletterSignupForm/reducers/voucherObjectReducers';
import pagination from '@common/Pagination/reducers/paginationReducers';
import quantitySelector from '@common/Product/QuantitySelector/reducers';
import product from '@common/Product/reducers';
import sizePicker from '@common/Product/SizePicker/store/reducers';
import recents from '@common/Recents/reducers/recentsReducers';
import searchResultPage from '@common/SearchResultsPage/reducers';
import sortBy from '@common/SortBy/reducers/sortByReducers';
import volumeDiscount from '@common/VolumeDiscount/reducers/volumeDiscount';
import volumeDiscountWithMDV from '@common/VolumeDiscount/reducers/volumeDiscountWithMDV';

export default combineReducers({
    customer,
    collections,
    favorites,
    recents,
    dashboard,
    dashboardClub,
    orderReturn,
    returns,
    ordersById,
    filters,
    sortBy,
    dialog,
    listing,
    pagination,
    sharedCart,
    CS,
    product,
    CMS,
    checkout,
    checkoutShopcart,
    addToCartFeedback,
    addToCart,
    myLists,
    activateDeals,
    quantitySelector,
    sideNavigation,
    newsletterSignup,
    voucher,
    volumeDiscount,
    volumeDiscountWithMDV,
    thankYouPage,
    globalSearch,
    sizePicker,
    searchResultPage
});
